<template>
  <div class="customizer-font customizer-trbl">
    <div class="row row-space-4">
      <div class="col-md-8">
        <label>Type</label>
        <select class="form-control" v-model="animationName">
          <option v-for="value in animationList" :key="value" :value="value">{{value | upperFirst}}</option>
        </select>
      </div>
      <div class="col-md-4" v-if="animationName !== 'none'">
        <label>Duration</label>
        <div class="input-group">
          <input type="number" class="form-control"
            :value="animationDuration | removeUnit"
            @input="animationDuration = addUnit($event.target.value, 's')">
          <div class="input-group-append">
            <span class="input-group-text" title="Second">S</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row row-space-4" v-if="animationName !== 'none'">
      <div class="col-md-6">
        <label>Timing Function</label>
        <select class="form-control" v-model="animationTimingFunction">
          <option v-for="value in animationTimingList" :key="value" :value="value">{{value | upperFirst}}</option>
        </select>
      </div>
      <div class="col-md-6">
        <label>Iteration Count</label>
        <input :type="setInputType(animationIterationCount)" class="form-control text-center" v-model="animationIterationCount" pattern="[infinite|\d+]">
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import filters from '@/mixins/filters'
import mapMultiComputed from '@/mixins/mapMultiComputed'

export default {
  mixins: [
    filters,
    mapMultiComputed('amptheme', [ 'animationName', 'animationTimingFunction', 'animationDuration', 'animationIterationCount' ], true)
  ],
  props: {
    category: String
  },
  computed: {
    animationList: function () {
      return [ 'none', 'marquee', 'bounce', 'flash', 'pulse' ]
    },
    animationTimingList: function () {
      return [ 'ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear', 'step-start', 'step-end' ]
    },
    ...mapState([ 'amptheme' ])
  }
}
</script>
